const TeamList = ({ children }) => (
  <ul className="list-unstyled">{children}</ul>
);

export default TeamList;
